import React, { InputHTMLAttributes, forwardRef } from 'react'
import cn from 'classnames'

import styles from './TextArea.module.scss'

interface TextAreaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  className?: string
  error?: string
}
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <div className={cn(className, styles.container)}>
        <textarea {...props} className={styles.input} ref={ref} />
        {error != null && error.length !== 0 ? (
          <span className={styles.error}>{error}</span>
        ) : null}
      </div>
    )
  }
)

TextArea.displayName = 'TextArea'
